/**
 * valumize API for managing assets
 * An asset mostly represents a company and contains basic information such as a name, description and currency as well as historical financial data such as revenues, ebitda or net debt. Each asset can have multiple asset valuations. An asset valuation may include calculations, forecasts etc. An asset valuation always refers to a specific date on which the report, which serves as the basis for the valuation, was created. Moreover, it always belongs to an asset and cannot exist independently of it.
 *
 * The version of the OpenAPI document: 0.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetValuationHistoryBaseRequest } from './asset-valuation-history-base-request';


/**
 * Optional pending history base mutation to apply atomically with an asset valuation save. The backend applies the mutation and a valuation reset in the same transaction as the save, so nothing is persisted unless the save succeeds. 
 */
export interface PendingHistoryBaseChange { 
    /**
     * Discriminator for which history base mutation to perform. SELECT_RECORD requires `historyRecordId`. CREATE_CUSTOM requires `customRequest`. DELETE requires neither. 
     */
    kind: PendingHistoryBaseChange.KindEnum;
    /**
     * Required when kind=SELECT_RECORD. Id of the existing financial history record to copy.
     */
    historyRecordId?: number;
    customRequest?: AssetValuationHistoryBaseRequest;
}
export namespace PendingHistoryBaseChange {
    export type KindEnum = 'SELECT_RECORD' | 'CREATE_CUSTOM' | 'DELETE';
    export const KindEnum = {
        SelectRecord: 'SELECT_RECORD' as KindEnum,
        CreateCustom: 'CREATE_CUSTOM' as KindEnum,
        Delete: 'DELETE' as KindEnum
    };
}


